import * as React from "react";
import { SimpleShowLayout, Show } from "react-admin";

import TextFieldRA from "../components/TextField";
import LayoutContainer from "../components/LayoutContainer";

const CategoryShow = (props) => (
  <LayoutContainer>
    <Show {...props}>
      <SimpleShowLayout>
        <TextFieldRA label="Supplier name" source="name" />
        <TextFieldRA label="Description" source="desc" />
        <TextFieldRA label="Business type" source="business_type" />
        <TextFieldRA label="Tax id" source="tax_id" />
        <TextFieldRA label="Contact person 1" source="contact1" />
        <TextFieldRA label="Contact person 2" source="contact2" />
        <TextFieldRA label="Phone" source="phone" required type="phone" />
        <TextFieldRA label="Email" source="email" />
        <TextFieldRA label="Address" source="address" />
      </SimpleShowLayout>
    </Show>
  </LayoutContainer>
);

export default CategoryShow;
